import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiStockInplantData, StockInplantFilter } from "./types";

interface StockInplantsResponse {
    stockInplants: ApiStockInplantData[];
}

/** Транспортный слой OMP — ВЗН СУ. */
export const stockInplantsApi = {
    /**
     * Загружает ВЗН СУ по фильтру (`stock/stockInplants.loadByFilter`).
     * @param params фильтр ВЗН СУ
     * @param config опции HTTP-запроса
     */
    load: async (
        params: {
            flt?: StockInplantFilter;
        },
        config?: RequestConfig,
    ): Promise<ApiStockInplantData[]> => {
        const data = await ompApiClient.postOmega<StockInplantsResponse>("stock/stockInplants.loadByFilter", params, config);

        return data.stockInplants;
    },
} as const;
